const updateHistory = () => {
  if ($('#quicklook-modal').is(':visible')) {
    return false;
  }

  let selected_variant = $('[data-product-select]').val();

  if (typeof selected_variant === 'undefined' || selected_variant == null) {
    if ($('[data-product-option-size].inactive.active').length) {
      selected_variant = $('[data-product-select]').find(':selected').val();
    } else {
      selected_variant = $('[data-product-select] option').first().val();
    }
  }

  const page_url = new URL(window.location.href);
  const search_params = new URLSearchParams(page_url.search);

  // We need to keep the previous QS due to marketing campaigns
  // Note that we keep it even if the variant changes (OOS variant gets redirected to in-stock variant) which might not be ideal to track the exact conversions but has been requested by Rockerbox
  const all_params = Object.fromEntries(search_params.entries());
  all_params.variant = selected_variant;
  if (search_params.has('color')) {
    delete all_params.color;
  }
  const qs = Object.keys(all_params).map((key) => `${key}=${all_params[key]}`).join('&');
  const new_url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${qs}`;
  window.history.replaceState({ path: new_url }, '', new_url);

  // We need to keep the previous QS due to marketing campaigns
  // if (search_params.get('variant') !== selected_variant) {
  //   const new_url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${selected_variant}`;
  //   window.history.replaceState({ path: new_url }, '', new_url);
  //    // window.history.pushState({ path: new_url }, '', new_url);
  // }

  return true;
};

const getProductJson = () => {
  if (!$('[data-product-json]').length) {
    return [];
  }
  return JSON.parse($('[data-product-json]').html());
};

const getProductCollectionsJson = () => {
  if ($('[data-product-collections-json]').length) {
    return JSON.parse($('[data-product-collections-json]').html());
  }
  
  return [];
};

const getSelectedVariantId = () => {
  return parseInt($('[data-product-select] option:selected').val(), 10);
};

const getSelectedVariantByIdJson = () => {
  const p_json = getProductJson();
  return _.find(p_json.variants, { id: getSelectedVariantId() });
};

const getVariantsByColor = (selected_color) => {
  const color_index = $('[data-option-color]').data('option-index');
  let filter_search = { option1: selected_color };

  if (color_index === 1) {
    filter_search = { option2: selected_color };
  }

  if (color_index === 2) {
    filter_search = { option3: selected_color };
  }

  return _.filter(getProductJson().variants, filter_search);
};

// Single option product (gift card for instance)
const getVariantBySingleOption = (selected_single_option) => {
  return _.filter(getProductJson().variants, { option1: selected_single_option })[0];
};

const getAvailableProductColors = () => {
  const product = getProductJson();
  const colors = [];
  product.variants.forEach((variant) => {
    if (variant.available) {
      if (!colors.includes(variant.option1)) {
        colors.push(variant.option1);
      }
    }
  });

  // console.log('available colors', colors);

  return colors;
};

export {
  updateHistory,
  getProductJson,
  getProductCollectionsJson,
  getSelectedVariantByIdJson,
  getSelectedVariantId,
  getVariantsByColor,
  getVariantBySingleOption,
  getAvailableProductColors,
};